export default defineAppConfig({
  ui: {
    toast: {
      slots: {
        root: 'relative group overflow-hidden bg-default shadow-lg rounded-lg ring ring-default p-4 flex gap-2.5 focus:outline-none w-full mt-[20px]',
        progress: 'absolute inset-x-0 bottom-0 h-[5px] z-[-1] w-full'
      }
    },
    drawer: {
      compoundVariants: [
        {
          direction: 'bottom',
          inset: false,
          class: {
            content: 'inset-x-0 bottom-0 rounded-t-[30px] border-none'
          }
        }
      ]
    },
    modal: {
      slots: {
        overlay: 'bg-[rgba(0,0,0,0.32)] flex items-center justify-center',
        header: 'border-none justify-center',
        body: 'border-none leading-[48px] p-0 text-center text-[38px] text-[#333333] px-[19px] font-[600] flex items-center justify-center',
        footer: 'flex border-t border-[#E7E7E7] p-0 h-[100px] text-[36px] font-[400]',
        close: 'hidden'
      },
      variants: {
        fullscreen: {
          false: {
            content: 'rounded-none w-[590px] min-h-[312px] custom-UModal'
          }
        }
      }
    },
    button: {
      slots: {
        base: ['font-[400]']
      }
    },
    switch: {
      slots: {
      },
      variants: {
        color: {
          primary: {
            base: 'data-[state=checked]:bg-(--ui-primary) focus-visible:outline-(--ui-primary)',
            icon: 'group-data-[state=checked]:text-(--ui-primary)'
          },
        },
        size: {
          md: {
            base: 'w-[108px] h-[54px] p-[6px]',
            thumb: 'w-[42px] h-[42px] data-[state=checked]:translate-x-[48px] data-[state=checked]:rtl:-translate-x-[48px]'
          }
        }
      }
    }
  }
})
